import axios from 'axios'
import _ from 'lodash'
// let numeral = require('numeral')

export default {}

export function PriceFormat(value) {
  if (!value) return 0.0
  value = Number(value)
  let priceValue = numeral(value).format('0.00.00')
  let priceValueFormat =
    priceValue.substr(0, priceValue.length - 3) +
    '' +
    priceValue.substr(length - 3) +
    ''
  return priceValueFormat
}

export function RecordAltFind(arr, callback) {
  for (var i = 0; i < arr.length; i++) {
    var match = callback(arr[i])
    if (match) {
      return arr[i]
      // eslint-disable-next-line no-unreachable
      break
    }
  }
}
